import client from "../api/client";
import {useAuth} from "../context/auth";

export const login = ({ login, password }) => {
  return client('/api/login', { body: { login, password } }).then(({ data }) => data.data);
};

export const forgotPassword = ({ login }) => {
  return client('/api/forgot-password', { body: { login } }).then(({ data }) => data);
};

export const resetPassword = ({ token, login, password, password_confirmation }) => {
  return client('/api/reset-password', { body: { token, login, password, password_confirmation } }).then(({ data }) => data);
};

export const logout = () => {
  return client('/api/logout', { body: {} }).then(({ data }) => data);
};

export const getUser = () => {
  return client('/api/users/profile').then(({ data }) => data.data).catch(()=>null);
};

export const can = (requiredAbilities=[]) => {
  const auth = useAuth();
  if (!auth){
    return false;
  }
  if ('string'===typeof requiredAbilities){
    requiredAbilities = [requiredAbilities];
  }
  if (!requiredAbilities || !requiredAbilities.length>0){
    return false;
  }
  const user = auth.currentUser;
  if (!user){
    return false;
  }
  if (!user.global_roles || !user.global_roles.length){
    return false;
  }

  if (user._all_abilities && user._all_abilities.length>0){
    let foundAbilities = requiredAbilities.filter((requiredAbility)=>{
      return user._all_abilities.includes(requiredAbility);
    });
    if (foundAbilities.length>0){
      return true;
    }
  }

  return false
};

export const hasRole = (requiredRoles=[]) => {
  const auth = useAuth();
  if (!auth){
    return false;
  }
  if ('string'===typeof requiredRoles){
    requiredRoles = [requiredRoles];
  }
  if (!requiredRoles || !requiredRoles.length>0){
    return false;
  }
  const user = auth.currentUser;
  if (!user){
    return false;
  }
  if (!user.global_roles || !user.global_roles.length){
    return false;
  }

  let foundRoles = requiredRoles.filter((requiredRole)=>{
    return user._all_roles.includes(requiredRole);
  });

  if (foundRoles.length){
    return true;
  }

  return false
};

export function useAuthService () {
  return {
    login,
    forgotPassword,
    resetPassword,
    logout,
    getUser,
    can,
    hasRole,
  };
}
